import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How quickly will I get access?',
  answer: "Instantly. As soon as your payment is processed, you'll be redirected to a secure download page and receive an email with your access links. You can start the protocol today."
}, {
  question: 'Is this a subscription?',
  answer: 'No. This is a one-time payment of $6.36. There are no hidden fees, recurring charges, or forced continuity programs.'
}, {
  question: "I'm incredibly busy. Will I have time for this?",
  answer: 'Yes. The protocol was specifically designed for busy professional women. The morning movement routine takes exactly 15 minutes, and the nutrition guidelines are simple enough to follow even if you eat out frequently.'
}, {
  question: 'Do I need any special equipment?',
  answer: 'None at all. The movement routine uses only your body weight, and the grocery list features common items you can find at any local supermarket.'
}, {
  question: 'How does the guarantee work?',
  answer: "If you complete the 7-day reset and don't feel a noticeable difference in your energy levels, bloating, or sleep quality, simply email our support team within 30 days for a full, no-questions-asked refund."
}];
export function FAQGuarantee() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-12">
          {/* Guarantee Column */}
          <div className="lg:col-span-5" data-id="element-13">
            <div className="sticky top-24" data-id="element-14">
              <h2 className="text-3xl md:text-4xl font-semibold mb-8" data-id="element-15">
                Risk-Free. <br data-id="element-16" />
                Instant Access.
              </h2>

              <div className="space-y-6" data-id="element-17">
                <div className="bg-white p-6 border border-cream-dark flex items-start space-x-4" data-id="element-18">
                  <ShieldCheckIcon className="w-8 h-8 text-sage flex-shrink-0" data-id="element-19" />
                  <div data-id="element-20">
                    <h4 className="font-serif text-lg font-medium mb-2" data-id="element-21">
                      30-Day Money-Back Guarantee
                    </h4>
                    <p className="text-sm text-teal-muted leading-relaxed" data-id="element-22">
                      Try the entire protocol. If you don't feel lighter, more
                      energized, and less stressed within 7 days, we'll refund
                      your $6.36 immediately.
                    </p>
                  </div>
                </div>

                <div className="bg-white p-6 border border-cream-dark flex items-start space-x-4" data-id="element-23">
                  <DownloadIcon className="w-8 h-8 text-sage flex-shrink-0" data-id="element-24" />
                  <div data-id="element-25">
                    <h4 className="font-serif text-lg font-medium mb-2" data-id="element-26">
                      Digital Delivery
                    </h4>
                    <p className="text-sm text-teal-muted leading-relaxed" data-id="element-27">
                      All materials are delivered digitally in PDF and video
                      format. Compatible with all smartphones, tablets, and
                      computers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Column */}
          <div className="lg:col-span-7" data-id="element-28">
            <h3 className="text-2xl font-serif mb-8" data-id="element-29">
              Frequently Asked Questions
            </h3>

            <div className="space-y-4" data-id="element-30">
              {faqs.map((faq, index) => <div key={index} className="border border-cream-dark bg-white overflow-hidden" data-id="element-31">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-cream/30 transition-colors focus:outline-none" aria-expanded={openIndex === index} data-id="element-32">
                    <span className="font-medium pr-8" data-id="element-33">{faq.question}</span>
                    <ChevronDownIcon className={`w-5 h-5 text-teal-muted transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-34" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-35">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-36">
                        <div className="px-6 pb-5 text-teal-muted text-sm leading-relaxed border-t border-cream-dark pt-4" data-id="element-37">
                          {faq.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}